import styled from 'styled-components';
import {
  DialogContentText,
  Paper,
} from '@mui/material';

const StyledPaper = styled(Paper)`
  padding: 16px;
`;

const StyledDialogContentText = styled(DialogContentText)`
  white-space: pre-line;
`;

export {
  StyledPaper,
  StyledDialogContentText,
};
